import React from 'react'
import ModalFormUI from './../../../widgets/form/ModalFormUI'
import InputTextSF from './../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const VendorAddModalUI = ({
    context, messageList, successMsg, errorList,
    createMode, submitted, onSubmit, onCancelClick, setErrorList,
    //
    vendorName, onVendorNameChange, vendorNameError, setVendorNameError,
    //
    ifscCode, onIfscCodeChange, ifscCodeError, setIfscCodeError,
    //
    bankAccountNumber, onBankAccountNumberChange, bankAccountNumberError, setBankAccountNumberError,
    //
    beneficiaryName, onBeneficiaryNameChange, beneficiaryNameError, setBeneficiaryNameError,
    //
    tdsCode, onTdsCodeChange, tdsList, tdsCodeError, setTdsCodeError,
    //
    state, onStateChange, stateList, stateError, setStateError,
    //
    selectedTdsType, onTdsTypeChange, tdsTypeList, tdsTypeError, setTdsTypeError
}) =>
    <ModalFormUI
        context={context}
        messageList={messageList}
        titleLabel='Add vendor without PAN'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={createMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='vendorName' label='Vendor name'
            required={true}
            value={vendorName} onChange={onVendorNameChange}
            error={vendorNameError}
            setError={setVendorNameError}
            autoFocus={true}
        />

        <InputSelectSF type='select' name='state' label='State'
            required={true}
            value={state} onChange={onStateChange} optionList={stateList}
            error={stateError} setError={setStateError}
        />

        <InputSelectSF type='select' name='tdsType' label='TDS type'
            required={true}
            value={selectedTdsType} onChange={onTdsTypeChange} optionList={tdsTypeList}
            error={tdsTypeError} setError={setTdsTypeError}
        />

        <InputSelectSF type='select' name='tdsCode' label='TDS'
            required={true}
            value={tdsCode} onChange={onTdsCodeChange} optionList={tdsList}
            error={tdsCodeError} setError={setTdsCodeError}
        />

        <InputTextSF type='text' name='bankAccountNumber' label='Bank account number'
            required={true}
            value={bankAccountNumber} onChange={onBankAccountNumberChange}
            error={bankAccountNumberError} setError={setBankAccountNumberError}
        />

        <InputTextSF type='text' name='ifscCode' label='IFSC code'
            required={true}
            value={ifscCode} onChange={onIfscCodeChange}
            error={ifscCodeError} setError={setIfscCodeError}
        />

        <InputTextSF type='text' name='beneficiaryName' label='Beneficiary name'
            required={true}
            value={beneficiaryName} onChange={onBeneficiaryNameChange}
            error={beneficiaryNameError} setError={setBeneficiaryNameError}
        />

    </ModalFormUI>

export default VendorAddModalUI;
